import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Bell } from 'lucide-react';
import { Announcement } from '@/types';

export default function NotificationBell() {
  const { currentUser } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [announcements] = useState<Announcement[]>([]);

  useEffect(() => {
    if (!currentUser) return;

    // Note: In production, use a more efficient approach like:
    // - Maintain a user-specific notifications collection
    // - Use Cloud Functions to copy announcements to user's notification inbox
    // - Real-time listeners for instant updates
    
    // For now, notification count is set to 0
    setUnreadCount(0);
  }, [currentUser]);

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        className="relative"
        onClick={() => setShowNotifications(!showNotifications)}
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <Badge
            variant="destructive"
            className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
          >
            {unreadCount}
          </Badge>
        )}
      </Button>

      {/* Notifications Dropdown */}
      {showNotifications && (
        <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border z-50">
          <div className="p-4 border-b">
            <h3 className="font-semibold">Notifications</h3>
          </div>
          <div className="max-h-96 overflow-y-auto">
            {announcements.length === 0 ? (
              <div className="p-8 text-center text-muted-foreground">
                <Bell className="mx-auto h-12 w-12 mb-2 opacity-20" />
                <p>No new notifications</p>
              </div>
            ) : (
              <div className="divide-y">
                {announcements.map((announcement) => (
                  <div key={announcement.id} className="p-4 hover:bg-gray-50 cursor-pointer">
                    <p className="text-sm">{announcement.message}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {announcement.createdAt.toLocaleDateString()}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}


